import {useTranslation} from "react-i18next";
import {techStacks} from "../../constants/services/customSoftware";
import SlideUp from "../ui/SlideUp";
import React from "react";

const TechStack = () => {
  const { t } = useTranslation();
  return (
    <section className="py-28 add-square-bg">
      <div className="md:w-theme-container w-mobile-container mx-auto">
        <div className="mb-2">
          <SlideUp>
            <h2 className="text-2xl text-gray-800 mb-2">{t('common.techStack')}</h2>
            <p className="text-base text-gray-500 mb-10">{t('common.deployedYourApp')}</p>
          </SlideUp>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 gap-y-20 justify-between items-start">
          {techStacks.map((tech, index) => (
            <SlideUp key={index}>
              <div key={index} className="flex flex-col items-center bg-yellow-3000">
                <div className="md:w-24 md:h-24 w-16 h-16 rounded-lg transition">
                  <img
                    src={require(`../../assets/images/tech-stack/${tech.imgName}`)}
                    alt={tech.name}
                    className="object-contain w-full h-full"
                  />
                </div>
                <span className="mt-2 text-center text-sm text-gray-700">{tech.name}</span>
              </div>
            </SlideUp>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TechStack;
